import { HttpResult } from 'widgets-for-react'
import { cmsPageUrlSimpler } from '../../utils/cmsPageUrl'
import { SharepointPageData } from '../cmsPage/sharepointPageApi/types/pageData'
import { Links } from './footerState'

export type FooterData = {
  Title: string
  Link: {
    Url: string
    ContentType: SharepointPageData['ContentType'] | null
  }
  Column: string
  OrderInColumn: number
}[]

export const footerApi = async (): Promise<HttpResult<Links>> => {
  const res = await fetch('/api/v1/footer')

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: FooterData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data
      .sort((a, b) => a.OrderInColumn - b.OrderInColumn)
      .map((item) => ({
        title: item.Title,
        url:
          item.Link.ContentType === null
            ? item.Link.Url
            : cmsPageUrlSimpler({ ContentType: item.Link.ContentType, Path: item.Link.Url }),
        column: item.Column,
      })),
  }
}
